<p-progressBar class="mainProgress" mode="indeterminate" *ngIf="isLoading$ | async"></p-progressBar>
<div class="main p-input-filled">
    <app-cookie-banner></app-cookie-banner>
    <router-outlet></router-outlet>
    <div *ngIf="blockDocument$|async">
        <p-blockUI [blocked]="true"></p-blockUI>
        <p-progressSpinner class="progress"></p-progressSpinner>
    </div>

    <custom-message></custom-message>



    <app-blockable-div #dd>
    </app-blockable-div>
    <p-dialog [showHeader]="false" [closable]="false" [visible]="displayLoginDialog$|async" [modal]="true"
        [style]="{width: '608px', height:'720px'}" [draggable]="false" [resizable]="false">
        <app-sign-in-up *ngIf="displayLoginDialog$|async"></app-sign-in-up>
    </p-dialog>

</div>
